export default {
  baseUrl: process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:8000',
  siteUrl: 'dama-co.com/'
}
